export const sessionName = 'orbitid.session-token'

export const APP_NAME = 'OrbitID'

export const HOMEPAGE_URL = process.env.NEXT_PUBLIC_ORBITID_HOMEPAGE_URL || 'https://orbitid.com'

export const DOCS_URL = `${HOMEPAGE_URL}/docs`

export const TERMS_URL = `${HOMEPAGE_URL}/terms`

export const PRIVACY_URL = `${HOMEPAGE_URL}/privacy`

export const REFUNDS_URL = `${HOMEPAGE_URL}/refunds`

export const SUPPORT_EMAIL = 'support@orbitid.com'

export const HELPSCOUT_BEACON_ID = 'ffae067e-2cb2-4ae3-b1c2-1551823dad53'

export const SSO_CONNECTION_PRICE = 25

export const DSYNC_CONNECTION_PRICE = 25

export const SANDBOX_CONNECTION_LIMIT = 5
